import { PrismicLink, TextFromRichText } from './PrismicTypes';

export const GENERIC_LMI_CALCULATOR = 'PrismicGenericTemplateDataBodyLmiCalc';

export interface GenericLmiCalculatorPrimary {
  button_text?: TextFromRichText;
  button_link?: PrismicLink;
  calculator_heading?: TextFromRichText;
  disclaimer?: TextFromRichText;
  result_body?: TextFromRichText;
  result_heading?: TextFromRichText;
}

export interface GenericLmiCalculatorContent {
  __typename: typeof GENERIC_LMI_CALCULATOR;
  primary: GenericLmiCalculatorPrimary;
}
